import { render, staticRenderFns } from "./MessagingModeSwitcher.vue?vue&type=template&id=5b4a370e&scoped=true&"
import script from "./MessagingModeSwitcher.vue?vue&type=script&lang=js&"
export * from "./MessagingModeSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./MessagingModeSwitcher.vue?vue&type=style&index=0&id=5b4a370e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a370e",
  null
  
)

export default component.exports